import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { Button, LayerBottom, Input } from 'components'
import kiaSymbol from 'images/tmp_kia_symbol.png'
import hdSymbol from 'images/tmp_hyundai_symbol.png'
import styles from './index.module.css'

const FincarSearchFilter = () => {

	const App = useApp()
	const [tabMenu, setTabMenu] = useState(1)
	const [tabList, setTabList] = useState(0)

	const [companyLayer, setCompanyLayer] = useState(false)
	const [typeLayer, setTypeLayer] = useState(false)
	const [modelLayer, setModelLayer] = useState(false)
	const [yearLayer, setYearLayer] = useState(false)
	const [distanceLayer, setDistanceLayer] = useState(false)
	const [priceLayer, setPriceLayer] = useState(false)
	const [fuelLayer, setFuelLayer] = useState(false)
	const [optionLayer, setOptionLayer] = useState(false)
	const [colorLayer, setColorLayer] = useState(false)

	// 제조사/모델 레이어
	const openCompany = () => {
		setCompanyLayer(true)
	}
	const closeCompany = () => {
		setCompanyLayer(false)
	}

	// 차종 레이어
	const openType = () => {
		setTypeLayer(true)
	}
	const closeType = () => {
		setTypeLayer(false)
	}

	// 모델 레이어
	const openModel = () => {
		setModelLayer(true)
	}
	const closeModel = () => {
		setModelLayer(false)
	}

	// 연식 레이어
	const openYear = () => {
		setYearLayer(true)
	}
	const closeYear = () => {
		setYearLayer(false)
	}

	// 주행거리 레이어
	const openDistance = () => {
		setDistanceLayer(true)
	}
	const closeDistance = () => {
		setDistanceLayer(false)
	}

	// 가격 레이어
	const openPrice = () => {
		setPriceLayer(true)
	}
	const closePrice = () => {
		setPriceLayer(false)
	}

	// 연료 레이어
	const openFuel = () => {
		setFuelLayer(true)
	}
	const closeFuel = () => {
		setFuelLayer(false)
	}

	// 옵션 레이어
	const openOption = () => {
		setOptionLayer(true)
	}
	const closeOption = () => {
		setOptionLayer(false)
	}

	// 컬러 레이어
	const openColor = () => {
		setColorLayer(true)
	}
	const closeColor = () => {
		setColorLayer(false)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" />,
			right: undefined,
		})

		App.setShowNav(false)
		App.setMainClass("white")

	}, [])

	return (
		<div className="page">
			<div className="padding pt_30 pb_50 flex_1">
				<h3>차량조회</h3>
				<ul className="tab-round-box mt_30">
					<li onClick={() => setTabMenu(0)} className={tabMenu === 0 ? "on" : ""}>직접입력</li>
					<li onClick={() => setTabMenu(1)} className={tabMenu === 1 ? "on" : ""}>필터검색</li>
				</ul>
				<ul className="tab-round mt_30">
					<li onClick={() => setTabList(0)} className={tabList === 0 ? "active" : ""}>전체</li>
					<li onClick={() => setTabList(1)} className={tabList === 1 ? "active" : ""}>국산</li>
					<li onClick={() => setTabList(2)} className={tabList === 2 ? "active" : ""}>수입</li>
				</ul>

				<ul className={`${styles["option-filter"]} mt_20`}>

					{/* 제조사/모델 */}
					<li>
						<div className={styles.tit} onClick={openCompany}>
							<p>제조사/모델</p>
							<i className="icon icon_arrow_sm icon_arrow_md right" />
						</div>
						<div className={styles.option}>
							<div className={`${styles.tag} ${styles["inline-tag"]}`}>
								기아 <i className="icon icon_input_close" />
							</div>
						</div>
					</li>

					{/* 차종 */}
					<li>
						{/* 모델 항목 선택값이 있는 경우 비활성화 처리됨 */}
						<div className={`${styles.tit} ${styles.unselected}`} onClick={openType}>
							<p>차종</p>
							<i className="icon icon_arrow_sm icon_arrow_md right" />
						</div>
					</li>

					{/* 모델 */}
					<li>
						<div className={styles.tit} onClick={openModel}>
							<p>모델</p>
							<i className="icon icon_arrow_sm icon_arrow_md right" />
						</div>

						{/* 모델 등급 미선택 시 */}
						<div className={styles.option}>
							<div className={`${styles.tag} ${styles["inline-tag"]}`}>
								더 뉴 모하비 <i className="icon icon_input_close" />
							</div>
							<div className={styles.box}>
								<div className="flex-justify_between align_center">
									<p>등급</p>
									<span className={styles["txt-btn"]}>선택하기</span>
								</div>
							</div>
						</div>

						{/* 모델 등급만 선택, 세부등급 미선택 시 */}
						<div className={styles.option}>
							<div className={styles.box}>
								<div>
									<div>등급</div>
									<div className="flex-justify_between align_center mt_10">
										<div className={`${styles.tag} ${styles["inline-tag"]}`}>
											더 뉴 모하비 <i className="icon icon_input_close" />
										</div>
										<span className={styles["txt-btn"]}>수정하기</span>
									</div>
								</div>
								<div>
									<div className="flex-justify_between align_center">
										<div>세부등급</div>
										<span className={styles["txt-btn"]}>선택하기</span>
									</div>
								</div>
							</div>
						</div>

						{/* 모델 등급 선택, 세부등급 선택 시 */}
						<div className={styles.option}>
							<div className={styles.box}>
								<div>
									<div>등급</div>
									<div className="flex-justify_between align_center mt_10">
										<div className={`${styles.tag} ${styles["inline-tag"]}`}>
											더 뉴 모하비 <i className="icon icon_input_close" />
										</div>
										<span className={styles["txt-btn"]}>수정하기</span>
									</div>
								</div>
								<div>
									<div>등급</div>
									<div className="flex-justify_between align_center mt_10">
										<div className={`${styles.tag} ${styles["inline-tag"]}`}>
											2WD 노블레스 5인 <i className="icon icon_input_close" />
										</div>
										<span className={styles["txt-btn"]}>수정하기</span>
									</div>
								</div>
							</div>
						</div>
					</li>

					{/* 연식 */}
					<li>
						<div className={styles.tit} onClick={openYear}>
							<p>연식</p>
							<i className="icon icon_arrow_sm icon_arrow_md right" />
						</div>
						<div className={styles.option}>
							<div className={`${styles.tag} ${styles["inline-tag"]}`}>
								2016년 ~ 2019년 <i className="icon icon_input_close" />
							</div>
						</div>
					</li>

					{/* 주행거리 */}
					<li>
						<div className={styles.tit} onClick={openDistance}>
							<p>주행거리</p>
							<i className="icon icon_arrow_sm icon_arrow_md right" />
						</div>
						<div className={styles.option}>
							<div className={`${styles.tag} ${styles["inline-tag"]}`}>
								10,000km ~ 50,000km <i className="icon icon_input_close" />
							</div>
						</div>
					</li>

					{/* 가격 */}
					<li>
						<div className={styles.tit} onClick={openPrice}>
							<p>가격</p>
							<i className="icon icon_arrow_sm icon_arrow_md right" />
						</div>
						<div className={styles.option}>
							<div className={`${styles.tag} ${styles["inline-tag"]}`}>
								3,700만원 ~ 6,500만원 <i className="icon icon_input_close" />
							</div>
						</div>
					</li>

					{/* 연료 */}
					<li>
						<div className={styles.tit} onClick={openFuel}>
							<p>연료</p>
							<i className="icon icon_arrow_sm icon_arrow_md right" />
						</div>
						<div className={styles.option}>
							<div className={`${styles.tag} ${styles["block-tag"]}`}>
								가솔린 <i className="icon icon_input_close" />
							</div>
							<div className={`${styles.tag} ${styles["block-tag"]}`}>
								디젤 <i className="icon icon_input_close" />
							</div>
							<div className={`${styles.tag} ${styles["block-tag"]}`}>
								LPG겸용 <i className="icon icon_input_close" />
							</div>
							<div className={`${styles.tag} ${styles["block-tag"]}`}>
								하이브리드 <i className="icon icon_input_close" />
							</div>
						</div>
					</li>

					{/* 옵션 */}
					<li>
						<div className={styles.tit} onClick={openOption}>
							<p>옵션</p>
							<i className="icon icon_arrow_sm icon_arrow_md right" />
						</div>
						<div className={styles.option}>
							<div className={`${styles.tag} ${styles["block-tag"]}`}>
								후방감지센서 <i className="icon icon_input_close" />
							</div>
							<div className={`${styles.tag} ${styles["block-tag"]}`}>
								후방카메라 <i className="icon icon_input_close" />
							</div>
							<div className={`${styles.tag} ${styles["block-tag"]}`}>
								운전석에어백 <i className="icon icon_input_close" />
							</div>
							<div className={`${styles.tag} ${styles["block-tag"]}`}>
								사이드에어백 <i className="icon icon_input_close" />
							</div>
							<div className={`${styles.tag} ${styles["block-tag"]}`}>
								스마트키 <i className="icon icon_input_close" />
							</div>
							<div className={`${styles.tag} ${styles["block-tag"]}`}>
								하이패스 <i className="icon icon_input_close" />
							</div>
							<div className={`${styles.tag} ${styles["block-tag"]}`}>
								열선시트 <i className="icon icon_input_close" />
							</div>
						</div>
					</li>

					{/* 색상 */}
					<li>
						<div className={styles.tit} onClick={openColor}>
							<p>색상</p>
							<i className="icon icon_arrow_sm icon_arrow_md right" />
						</div>
						<div className={styles.option}>
							<div className={`${styles.tag} ${styles["block-tag"]}`}>
								<div className={styles["color-opt"]}>
									<span style={{ background: "#f5f5f5" }} />
								</div>
								은색 <i className="icon icon_input_close" />
							</div>
							<div className={`${styles.tag} ${styles["block-tag"]}`}>
								<div className={styles["color-opt"]}>
									<span style={{ background: "#000" }} />
								</div>
								검정 <i className="icon icon_input_close" />
							</div>
							<div className={`${styles.tag} ${styles["block-tag"]}`}>
								<div className={styles["color-opt"]}>
									<span style={{ background: "#434a6f" }} />
								</div>
								남색 <i className="icon icon_input_close" />
							</div>
							<div className={`${styles.tag} ${styles["block-tag"]}`}>
								<div className={`${styles["color-opt"]} ${styles.half}`}>
									<span style={{ background: "#fff" }} />
									<span style={{ background: "#000" }} />
								</div>
								검정투톤 <i className="icon icon_input_close" />
							</div>
							<div className={`${styles.tag} ${styles["block-tag"]}`}>
								<div className={`${styles["color-opt"]} ${styles.half}`}>
									<span style={{ background: "#000" }} />
									<span style={{ background: "#de0000" }} />
								</div>
								레드투톤 <i className="icon icon_input_close" />
							</div>
						</div>
					</li>
				</ul>
			</div>

			<div className="flex-shrink_0 padding pt_0 flex-align_center">
				<Button className="btn btn--big btn--gray flex_1">초기화</Button>
				<Button className="btn btn--big ml_10 flex_2">15,512대 조회하기</Button>
			</div>

			<Company show={companyLayer} closeLayer={closeCompany} />
			<Type show={typeLayer} closeLayer={closeType} />
			<Model show={modelLayer} closeLayer={closeModel} />
			<Year show={yearLayer} closeLayer={closeYear} />
			<Distance show={distanceLayer} closeLayer={closeDistance} />
			<Price show={priceLayer} closeLayer={closePrice} />
			<Fuel show={fuelLayer} closeLayer={closeFuel} />
			<Option show={optionLayer} closeLayer={closeOption} />
			<Color show={colorLayer} closeLayer={closeColor} />
		</div>
	)
}

// 제조사/모델 레이어
const Company = ({ show, closeLayer }) => {
	return (
		<LayerBottom title="제조사" show={show} closeLayer={closeLayer}>
			<ul className={styles["select-company"]}>
				<li>
					<strong>국산</strong>
					<ul>
						<li>
							<div className="img-box img-symbol">
								<img src={kiaSymbol} alt="" />
							</div>
							<p>기아</p>
						</li>
						<li>
							<div className="img-box img-symbol">
								<img src={hdSymbol} alt="" />
							</div>
							<p>현대</p>
						</li>
						<li>
							<div className="img-box img-symbol">
								<img src={kiaSymbol} alt="" />
							</div>
							<p>르노삼성</p>
						</li>
						<li>
							<div className="img-box img-symbol">
								<img src={hdSymbol} alt="" />
							</div>
							<p>쌍용</p>
						</li>
					</ul>
				</li>
				<li>
					<strong>수입</strong>
					<ul>
						<li>
							<div className="img-box img-symbol">
								<img src={kiaSymbol} alt="" />
							</div>
							<p>메르세데스 벤츠</p>
						</li>
						<li>
							<div className="img-box img-symbol">
								<img src={hdSymbol} alt="" />
							</div>
							<p>BMW</p>
						</li>
					</ul>
				</li>
			</ul>
		</LayerBottom>
	)
}

// 차종 레이어
const Type = ({ show, closeLayer }) => {
	return (
		<LayerBottom show={show} title="차종" closeLayer={closeLayer} outside={
			<div className="flex-align_center">
				<Button className="btn btn--big btn--gray btn-layer flex-center" style={{ width: "14rem" }}><i className="icon icon_refresh_white mr_5" />초기화</Button>
				<Button className="btn btn--big btn-layer flex_1" onClick={() => closeLayer()}>선택하기</Button>
			</div>
		}>
			<div>
				<div className="flex-align_center">
					<i className="checkMark" />
					<span className="ml_10">전체선택</span>
				</div>
				<ul className="opt-menu mt_20">
					<li>경차</li>
					<li>소형/준중형</li>
					<li className="active">중형차</li>
					<li className="active">대형/고급</li>
					<li className="active">스포츠카</li>
					<li>RV/레저용</li>
					<li>SUV/지프</li>
					<li>버스/화물</li>
				</ul>
			</div>
		</LayerBottom>
	)
}

// 모델 레이어 (모델 -> 등급 -> 세부등급 선택)
const Model = ({ show, closeLayer }) => {
	return (
		<LayerBottom title="모델" show={show} closeLayer={closeLayer}>
			<ul className="select-list">
				<li>K3</li>
				<li>K5</li>
				<li>K8</li>
				<li>K9</li>
				<li>로체</li>
				<li>리오</li>
				<li>레이</li>
				<li>모닝</li>
				<li className="on">모하비</li>
			</ul>
		</LayerBottom>
	)
}

// 연식 레이어
const Year = ({ show, closeLayer }) => {
	return (
		<LayerBottom show={show} title="연식" closeLayer={closeLayer} outside={
			<div className="flex-align_center">
				<Button className="btn btn--big btn--gray btn-layer flex-center" style={{ width: "14rem" }}><i className="icon icon_refresh_white mr_5" />초기화</Button>
				<Button className="btn btn--big btn-layer flex_1" onClick={() => closeLayer()}>입력하기</Button>
			</div>
		}>
			<div className={`${styles["ui-slider"]} mt_10`}>
				<div className={styles} style={{ left: "30%", width: "50%" }} />
				<span style={{ left: "30%" }} />
				<span style={{ left: "80%" }} />
			</div>
			<div className="flex-justify_between align_center mt_20" style={{ color: "#666", fontWeight: 500 }}>
				<span>1980년</span>
				<span>2022년</span>
			</div>
			<div className="flex-align_center mt_30">
				<div className="form-group">
					<Input maxlength="4" className="withMag" defaultValue="2018" />
					<span className="floating" style={{ fontSize: "1.6rem" }}>년</span>
				</div>
				<span className="mx_10">-</span>
				<div className="form-group">
					<Input maxlength="4" className="withMag" defaultValue="2022" />
					<span className="floating" style={{ fontSize: "1.6rem" }}>년</span>
				</div>
			</div>
		</LayerBottom>
	)
}

// 주행거리 레이어
const Distance = ({ show, closeLayer }) => {
	return (
		<LayerBottom show={show} title="주행거리" closeLayer={closeLayer} outside={
			<div className="flex-align_center">
				<Button className="btn btn--big btn--gray btn-layer flex-center" style={{ width: "14rem" }}><i className="icon icon_refresh_white mr_5" />초기화</Button>
				<Button className="btn btn--big btn-layer flex_1" onClick={() => closeLayer()}>입력하기</Button>
			</div>
		}>
			<div className={`${styles["ui-slider"]} mt_10`}>
				<div className={styles} style={{ left: 0, width: "100%" }} />
				<span style={{ left: 0 }} />
				<span style={{ left: "100%" }} />
			</div>
			<div className="flex-justify_between align_center mt_20" style={{ color: "#666", fontWeight: 500 }}>
				<span>0km</span>
				<span>200,000km 초과</span>
			</div>
			<div className="flex-align_center mt_30">
				<div className="form-group">
					<Input defaultValue="10,000" maxlength="7" className="withMag" />
					<span className="floating" style={{ fontSize: "1.6rem" }}>km</span>
				</div>
				<span className="mx_10">-</span>
				<div className="form-group">
					<Input defaultValue="50,000" maxlength="7" className="withMag" />
					<span className="floating" style={{ fontSize: "1.6rem" }}>km</span>
				</div>
			</div>
		</LayerBottom>
	)
}

// 가격 레이어
const Price = ({ show, closeLayer }) => {
	return (
		<LayerBottom show={show} title="가격" closeLayer={closeLayer} outside={
			<div className="flex-align_center">
				<Button className="btn btn--big btn--gray btn-layer flex-center" style={{ width: "14rem" }}><i className="icon icon_refresh_white mr_5" />초기화</Button>
				<Button className="btn btn--big btn-layer flex_1" onClick={() => closeLayer()}>입력하기</Button>
			</div>
		}>
			<div className={`${styles["ui-slider"]} mt_10`}>
				<div className={styles} style={{ left: 0, width: "100%" }} />
				<span style={{ left: 0 }} />
				<span style={{ left: "100%" }} />
			</div>
			<div className="flex-justify_between align_center mt_20" style={{ color: "#666", fontWeight: 500 }}>
				<span>0만원</span>
				<span>10,000만원 초과</span>
			</div>
			<div className="flex-align_center mt_30">
				<div className="form-group">
					<Input defaultValue="3,700" maxlength="6" className="withMag" />
					<span className="floating" style={{ fontSize: "1.6rem" }}>만원</span>
				</div>
				<span className="mx_10">-</span>
				<div className="form-group">
					<Input defaultValue="10,000" maxlength="6" className="withMag" />
					<span className="floating" style={{ fontSize: "1.6rem" }}>만원 초과</span>
				</div>
			</div>
		</LayerBottom>
	)
}

// 연료 레이어
const Fuel = ({ show, closeLayer }) => {
	return (
		<LayerBottom show={show} title="연료" closeLayer={closeLayer} outside={
			<div className="flex-align_center">
				<Button className="btn btn--big btn--gray btn-layer flex-center" style={{ width: "14rem" }}><i className="icon icon_refresh_white mr_5" />초기화</Button>
				<Button className="btn btn--big btn-layer flex_1" onClick={() => closeLayer()}>선택하기</Button>
			</div>
		}>
			<div>
				<div className="flex-align_center">
					<i className="checkMark" />
					<span className="ml_10">전체선택</span>
				</div>
				<ul className="opt-menu mt_20">
					<li className="active">가솔린</li>
					<li className="active">디젤</li>
					<li className="active">LPG</li>
					<li>LPG겸용</li>
					<li className="active">하이브리드</li>
					<li>기타</li>
				</ul>
			</div>
		</LayerBottom>
	)
}

// 옵션 레이어
const Option = ({ show, closeLayer }) => {

	const [menuOpen, setMenuOpen] = useState(0)

	return (
		<LayerBottom show={show} title="옵션" closeLayer={closeLayer} outside={
			<div className="flex-align_center">
				<Button className="btn btn--big btn--gray btn-layer flex-center" style={{ width: "14rem" }}><i className="icon icon_refresh_white mr_5" />초기화</Button>
				<Button className="btn btn--big btn-layer flex_1" onClick={() => closeLayer()}>선택하기</Button>
			</div>
		}>
			<ul className="accordion-list">
				<li className={menuOpen === 0 ? "active" : ""} onClick={() => setMenuOpen(0)}>
					<div className="flex-justify_between align_center">
						<div className="flex-align_center bold">외관/내장 <span className="text-blue ml_5">4</span></div>
						<i className="icon icon_arrow_sm bottom" />
					</div>
					<div className="menu-open mt_20">
						<div className="flex-align_center">
							<i className="checkMark" />
							<span className="ml_10">전체선택</span>
						</div>
						<ul className="menu-select mt_10">
							<li className="on">후방감지센서</li>
							<li className="on">운전석 에어백</li>
							<li>커튼에어백</li>
							<li className="on">사이드 에어백</li>
							<li>후방카메라</li>
						</ul>
					</div>
				</li>
				<li className={menuOpen === 1 ? "active" : ""} onClick={() => setMenuOpen(1)}>
					<div className="flex-justify_between align_center">
						<div className="flex-align_center bold">편의/멀티미디어 <span className="text-blue ml_5">1</span></div>
						<i className="icon icon_arrow_sm bottom" />
					</div>
					<div className="menu-open mt_20">
						<ul className="menu-select">
							<li className="on">내비게이션</li>
							<li className="on">스마트키</li>
							<li>사운드</li>
							<li>통풍시트</li>
							<li>열선시트</li>
						</ul>
					</div>
				</li>
			</ul>
		</LayerBottom>
	)
}

// 색상 레이어
const Color = ({ show, closeLayer }) => {
	return (
		<LayerBottom show={show} title="색상" closeLayer={closeLayer} outside={
			<div className="flex-align_center">
				<Button className="btn btn--big btn--gray btn-layer flex-center" style={{ width: "14rem" }}><i className="icon icon_refresh_white mr_5" />초기화</Button>
				<Button className="btn btn--big btn-layer flex_1" onClick={() => closeLayer()}>선택하기</Button>
			</div>
		}>
			<div>
				<div className="flex-align_center">
					<i className="checkMark" />
					<span className="ml_10">전체선택</span>
				</div>
				<ul className="opt-menu mt_20">
					<li className="flex-align_center active">
						<div className={styles["color-opt"]}>
							<span style={{ background: "#f5f5f5" }} />
						</div>
						은색
					</li>
					<li className="flex-align_center">
						<div className={styles["color-opt"]}>
							<span style={{ background: "#000" }} />
						</div>
						검정
					</li>
					<li className="flex-align_center">
						<div className={styles["color-opt"]}>
							<span style={{ background: "#434a6f" }} />
						</div>
						남색
					</li>
					<li className="flex-align_center">
						<div className={`${styles["color-opt"]} ${styles.half}`}>
							<span style={{ background: "#fff" }} />
							<span style={{ background: "#000" }} />
						</div>
						검정투톤
					</li>
					<li className="flex-align_center">
						<div className={`${styles["color-opt"]} ${styles.half}`}>
							<span style={{ background: "#000" }} />
							<span style={{ background: "#de0000" }} />
						</div>
						레드투톤
					</li>
				</ul>
			</div>
		</LayerBottom>
	)
}

export default FincarSearchFilter